import SiteNav from './components/SiteNav';
import HeroSection from './components/HeroSection';
import StatusSection from './components/StatusSection';
import GuideSection from './components/GuideSection';
import PreventGridSection from './components/PreventGridSection';
import TrustSection from './components/TrustSection';
import FaqSection from './components/FaqSection';
import BookmarkCta from './components/BookmarkCta';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen w-full min-w-[320px] bg-background-50 font-sans text-foreground-950 antialiased">
      <SiteNav />
      <main>
        <HeroSection />
        <StatusSection />
        <GuideSection />
        <PreventGridSection />
        <TrustSection />
        <FaqSection />
        <BookmarkCta />
      </main>
      <SiteFooter />
    </div>
  );
}